module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detailsHeader"
  }, [_c('span', {
    staticClass: "detailsHeader-goback"
  }), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "icon-closed",
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details-title"
  }, [_vm._v("\n\t\t\t商品详情\n\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "icon-cart-group"
  }, [_c('span', {
    staticClass: "icon-cart",
    on: {
      "click": _vm.goShopCart
    }
  }, [_vm._v(_vm._s(_vm.counter))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60a9f4c0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/productDetail/proDetailHeader.vue
// module id = 574
// module chunks = 1